import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Button } from 'hljd'
import SelfInput from './SelfInput'
import ImgList from './ImgList'
import Store from './store'
import Style from './style.module.less'
import { toJS } from 'mobx'
import { HLJ_STATISTIC } from '@util'

const FormItem = Form.Item

@inject('parentStore')
@Form.create()
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(props.parentStore)
  }

  componentDidMount() {
    const {
      getAltasList,
      parent_store: { atlas_id }
    } = this.store
    if (atlas_id) {
      getAltasList(atlas_id)
    }
    HLJ_STATISTIC({
      event_type: 'page_jump'
    })
  }

  formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 3 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 15 }
    }
  }

  saveAtlas = () => {
    const {
      form: { validateFields }
    } = this.props
    validateFields((err, values) => {
      if (!err) {
        this.store.parent_store.saveAtlas(values)
      }
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { detail } = this.store

    return (
      <div className={Style.altas}>
        <FormItem label="图集标题" {...this.formItemLayout}>
          {getFieldDecorator('title', {
            initialValue: detail.title || '',
            rules: [
              { required: true, message: '图集标题必须填' },
              { max: 20, message: '不可超过20个字' }
            ]
          })(
            <SelfInput
              placeholder="为方便查询，建议您取名为：×××先生&×××女士，限20字以内"
              style={{ width: 500 }}
              maxLength={20}
            />
          )}
        </FormItem>
        <FormItem label="图集照片" {...this.formItemLayout}>
          {getFieldDecorator('photoList', {
            initialValue: detail.photoList ? toJS(detail.photoList) : [],
            rules: [{ required: true, message: '图集照片必须上传' }]
          })(<ImgList />)}
        </FormItem>
        <div className={Style.footer}>
          {/* <Button type="primary" onClick={this.saveAtlas}>
            保存图集并分享
          </Button> */}
          <Button type="primary" onClick={this.saveAtlas}>
            保存图集
          </Button>
        </div>
      </div>
    )
  }
}
